import { gql } from '@apollo/client'

export default gql(`
    query{
        getVodSettings{
            aws_region
            callbackUrl
            cognitoClientId
            cognitoPoolId
            encodingTemplate
            id
            mediaVodReqUrl
            password
            requestUrl
            username
            vodRequestUrl
            x_api_key
        }
    }`
)
